import { LogIn, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function AdminLogin() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (user?.is_admin) return <Navigate to="/admin" replace />;

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 text-white px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-blue-600/20 border border-blue-500/40 grid place-items-center mx-auto">
          <Shield className="w-8 h-8 text-blue-400" />
        </div>
        <div className="text-xs tracking-[0.3em] uppercase font-display font-semibold text-blue-400 mt-6">Espace administrateur</div>
        <h1 className="font-heading text-4xl font-normal italic tracking-tight mt-3">Connexion</h1>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Réservé aux membres de l'équipe Reflectum Pellicule.
          Connectez-vous avec votre compte Google autorisé.
        </p>
        <Button
          onClick={startLogin}
          data-testid="admin-login-google"
          className="mt-8 rounded-full bg-white text-slate-900 hover:bg-slate-100 h-14 px-8 text-base font-medium w-full sm:w-auto"
        >
          <LogIn className="w-4 h-4 mr-2" />
          Se connecter avec Google
        </Button>
      </div>
    </div>
  );
}
